import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-group-card',
  templateUrl: './group-card.component.html',
  styleUrl: './group-card.component.css'
})
export class GroupCardComponent {
  @Input() groupName: any; // Adjust the type as needed
  @Input() title: string; // Type for title
}
